export const BookingStepsEnum = Object.freeze({
    Clinic: 1,
    Treatment: 2,
    TimeSlot: 3,
    ClientInfo: 4,
})
